var path = 'components/login/login.template.html';
var html = "<px-login title=AirBase> <header-icon><div class=smb-login-icon></div></header-icon> </px-login> <footer class=smb-app-footer layout=column layout-gt-xs=row layout-align=\"start center\"> <md-button target=_blank href=./acceptable-use-policy> <translate>Acceptable Use Policy</translate> </md-button> <md-button target=_blank href=./privacy-policy> <translate>Privacy Policy</translate> </md-button> <md-button target=_blank href=./terms-of-use-and-subscription> <translate>Terms of Use</translate> </md-button> </footer> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/login/login.template.html
// module id = 194
// module chunks = 1